import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import authSlice, { authSliceName } from './authSlice';
// import layoutSlice, { layoutSliceName } from './layoutSlice'; // TODO: 삭제처리
import layoutSlice, { layoutSliceName } from './layout/layoutSlice';
import searchSlice, { searchSliceName } from './searchSlice';
import keywordSlice, { keywordSliceName } from './keywordSlice';
import keywordOptimizationSlice, { keywordOptimizationSliceName } from './keyword/keywordOptimizationSlice';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import keywordInsightSlice, { keywordInsightSliceName } from './keyword/keywordInsightSlice';
import keywordSuggestionSlice, { keywordSuggestionSliceName } from './keyword/keywordSuggestionSlice';
import keywordExploreSlice, { keywordExploreSliceName } from './keyword/keywordExploreSlice';
import keywordTranslatorSlice, { keywordTranslatorSliceName } from './keyword/keywordTranslatorSlice';
import keywordTrackingSlice, { keywordTrackingSliceName } from './keyword/keywordTrackingSlice';
import rankingSlice, { rankingSliceName } from './ranking/rankingSlice';
import serviceSlice, { serviceSliceName } from './service/serviceSlice';
import alertSlice, { alertSliceName } from './account/alertSlice';
import teamSlice, { teamSliceName } from './account/teamSlice';
import appSlice, { appSliceName } from './appSlice';

const store = configureStore({
  reducer: {
    [authSliceName]: authSlice,
    [layoutSliceName]: layoutSlice,
    [searchSliceName]: searchSlice,
    [keywordSliceName]: keywordSlice,
    [keywordTrackingSliceName]: keywordTrackingSlice,
    [keywordOptimizationSliceName]: keywordOptimizationSlice,
    [keywordInsightSliceName]: keywordInsightSlice,
    [keywordSuggestionSliceName]: keywordSuggestionSlice,
    [keywordExploreSliceName]: keywordExploreSlice,
    [keywordTranslatorSliceName]: keywordTranslatorSlice,
    [rankingSliceName]: rankingSlice,
    [serviceSliceName]: serviceSlice,
    [alertSliceName]: alertSlice,
    [teamSliceName]: teamSlice,
    [appSliceName]: appSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: true,
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
